import { useEffect, useState } from 'react';

// True when the screen has room for two phone-width panes side by side: an
// unfolded iPhone Duo held like a book, an iPad in landscape, a laptop. Driven
// by the viewport, never by device type, so a Duo in Split View (each half is
// phone-sized), a folded Duo and a rotated Duo all get the phone layout.
//
// The height floor keeps a phone in landscape (932 x 430) out: two panes at
// that height leave no room for the content between the header and footer.
export const WIDE_QUERY = '(min-width: 900px) and (min-height: 560px)';

const matches = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(WIDE_QUERY).matches
    : false;

export function useIsWide(): boolean {
  const [wide, setWide] = useState(matches);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(WIDE_QUERY);
    const onChange = () => setWide(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return wide;
}
